// extracted by mini-css-extract-plugin
export default {"swiper":"Slider_swiper__sq-gp","SwiperSlide":"Slider_SwiperSlide__rzIiH"};